export default __webpack_public_path__ + "../staticImages/glass-red.png";